export default {
  ADVERTS_PLAYING: 'adverts:playing',
  ADVERTS_PAUSE: 'adverts:pause',
  ADVERTS_BUFFERING: 'adverts:buffering',
  LOADING: 'loading',
  ERROR: 'error',
  PLAYING: 'playing',
  STOPPED: 'stopped',
  PAUSE: 'pause',
  WAITING_INTERACTION: 'interaction:waiting',
};
